import * as devisConf from '@/configuration/devisConf';

export function toMontantRemiseFront(typeRemise, remise) {
  if (typeRemise === devisConf.PERSONALISE) {
    return remise;
  }
  return Math.abs(remise);
}

export function fromMontantRemiseFront(ligneCommande, typeRemiseFront, montantRemiseFront) {
  ligneCommande.remise = (
    typeRemiseFront === devisConf.TYPE_REMISE_FRONT_REMISE_MONTANT
    || typeRemiseFront === devisConf.TYPE_REMISE_FRONT_REMISE_POURCENTAGE)
    ? parseFloat(montantRemiseFront) * -1 : parseFloat(montantRemiseFront);
}

export function toTypeRemiseFront(typeRemise, remise) {
  if (typeRemise === devisConf.POURCENTAGE) {
    if (remise <= 0) return devisConf.TYPE_REMISE_FRONT_REMISE_POURCENTAGE;
    return devisConf.TYPE_REMISE_FRONT_MAJORATION_POURCENTAGE;
  } if (typeRemise === devisConf.MONTANT) {
    if (remise <= 0) return devisConf.TYPE_REMISE_FRONT_REMISE_MONTANT;
    return devisConf.TYPE_REMISE_FRONT_MAJORATION_MONTANT;
  }
  return typeRemise;
}

export function fromTypeRemiseFront(ligneCommande, typeRemiseFront) {
  if (typeRemiseFront === devisConf.TYPE_REMISE_FRONT_REMISE_POURCENTAGE
    || typeRemiseFront === devisConf.TYPE_REMISE_FRONT_MAJORATION_POURCENTAGE) {
    ligneCommande.typeRemise = devisConf.POURCENTAGE;
  } else if (typeRemiseFront === devisConf.TYPE_REMISE_FRONT_REMISE_MONTANT
    || typeRemiseFront === devisConf.TYPE_REMISE_FRONT_MAJORATION_MONTANT) {
    ligneCommande.typeRemise = devisConf.MONTANT;
  } else {
    ligneCommande.typeRemise = typeRemiseFront;
  }
  if (((typeRemiseFront === devisConf.TYPE_REMISE_FRONT_REMISE_POURCENTAGE
    || typeRemiseFront === devisConf.TYPE_REMISE_FRONT_REMISE_MONTANT)
    && ligneCommande.remise > 0)
    || ((typeRemiseFront === devisConf.TYPE_REMISE_FRONT_MAJORATION_POURCENTAGE
      || typeRemiseFront === devisConf.TYPE_REMISE_FRONT_MAJORATION_MONTANT)
      && ligneCommande.remise <= 0)) {
    ligneCommande.remise *= -1;
  }
}
